define('modules/common/controller/FascicoloDocumenti',[], function() {
    var Controller = function(
        $scope,
        $window,
        $state,
        $stateParams,
        DocumentiFascicolo,
        DownloadDocumento,
        DettagliFascicolo,
        $location) {

        $scope.aliasStduio = $stateParams.aliasStudio;
        $scope.hrefDocumenti = $stateParams.hrefDocumenti;
        $scope.documentiFascicolo = [];

        $scope.idCartella = $location.search().idCartella || 0;

        var loadCartelle = function() {
            DocumentiFascicolo.loadCartelle($stateParams.hrefDocumenti.split('___').join('/'), $scope.idCartella)
            .then(function(response) {
                $scope.documentiFascicolo = response.documenti;
                $scope.cartelleFascicolo = response.cartelle;
                $scope.cartellaPadre = response.cartellapadre;
                $scope.cartellacorrente = response.cartellacorrente;
            }, function(error) {
                console.log(error);
            });
        };
        
        loadCartelle();
        

        DettagliFascicolo.getIntestazione(
            $scope.hrefFascicologlobal).then(function(intestazione) {
            $scope.intestazione = intestazione;
        });

        $scope.download = function(id,doc) {
            DownloadDocumento.download(id).then(function(link) {
                doc.err = '';
                $window.location.href = link;
          },function(err) {
               doc.err = err.data;
          });
        };

        $scope.open = function(idCartella) {
            $location.search("idCartella",idCartella);
            $scope.idCartella = idCartella;
            loadCartelle();
        };

        $scope.goBack = function() {
           $state.go('fascicolo.dettagli',{aliasStudio: $scope.aliasStduio,hrefFascicolo:$stateParams.hrefFascicolo});
        };



    };

    return [
        "$scope",
        "$window",
        "$state",
        "$stateParams",
        "DocumentiFascicolo",
        "DownloadDocumento",
        "DettagliFascicolo",
        "$location",
        Controller];
});

